export default __webpack_public_path__ + "static/media/space.a9c47e8d.webp";